import { render, staticRenderFns } from "./SequencingWorkshops.vue?vue&type=template&id=40ed4b9d&scoped=true&"
import script from "./SequencingWorkshops.vue?vue&type=script&lang=js&"
export * from "./SequencingWorkshops.vue?vue&type=script&lang=js&"
import style0 from "./SequencingWorkshops.vue?vue&type=style&index=0&id=40ed4b9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ed4b9d",
  null
  
)

export default component.exports